import { Box, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { WithPerspectives } from '~/components/MyWorkspace/ManagePerspectives';
import { Widget } from '~/components/MyWorkspace/Widget';
import { useSxStyles } from '~/scenes/MyWorkspace/components/Widgets/components/MyTeamAbsencesWidget/useStyles';

import { WidgetProps } from '../../data/widgets';

import { Content } from './components/Content';
import { Legend } from './components/Legend';
import { useMyTeamAbsencesWidget } from './useMyTeamAbsencesWidget';

export interface MyTeamAbsencesWidgetProps
  extends WidgetProps<WithPerspectives> {}

export const MyTeamAbsencesWidget: React.FC<MyTeamAbsencesWidgetProps> = ({
  title,
  config,
  width,
}) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    loading,
    teamAbsences,
    failedToLoad,
    publicHolidays,
    isTabDisabled,
    absencesRange: { startDate, endDate },
  } = useMyTeamAbsencesWidget(config);

  return (
    <>
      <Widget
        title={title || t('myTeamAbsences')}
        content={
          <Content
            teamAbsencesLoading={loading}
            teamAbsences={teamAbsences}
            publicHolidays={publicHolidays}
            failedToLoadTeamAbsences={failedToLoad}
            containerWidth={width}
            shouldRedirect={!isTabDisabled}
          />
        }
        actions={
          <Box sx={sxStyles.widgetActions}>
            <Legend teamAbsences={teamAbsences} />
            <Typography
              variant={'caption'}
              sx={sxStyles.absenceRange}
            >{`${moment(startDate).format('L')} - ${moment(endDate).format(
              'L',
            )}`}</Typography>
          </Box>
        }
      />
    </>
  );
};
